module.exports = __webpack_public_path__ + "img/customer-service.24fd85f4.webp";